// libs
import React, {useEffect, useState} from "react";
import { useTranslation } from "react-i18next";
import ReactApexChart from "react-apexcharts";

// utils
import formatDatesSet from "../../Utils/Date/Dateset";

const FillingGraph = (props) => {
	const { data, dateConfigs } = props;

	const { t, i18n } = useTranslation();

	const [fillings, setFillings] = useState([]);

	useEffect(() => {
		let previousReading = null;

		let fillDates = [];
		let fillItems = [];

		data.forEach((item) => {
			if (fillDates.indexOf(item.lastFill) === -1) {
				fillDates.push(item.lastFill);
				fillItems.push(item)
			}
		});

		let newArray = [];
		fillItems.forEach((fillItem) => {
			let previousReading = data.filter((item) => {
				return item.lastRead < fillItem.lastFill
			}).sort((item1, item2) => {
				return item1.lastRead - item2.lastRead
			}).pop()

			if (previousReading){
				newArray.push({
					fillDate: fillItem.lastFill,
					qtyBeforeFill:previousReading.correctedVolume,
					qtyFilled:fillItem.correctedVolume-previousReading.correctedVolume,
					currentlevel: fillItem.correctedVolume
				});
			}
		})

		setFillings(newArray);
	}, [data]);

	const mapSeries = () => {
		return [
			{
				name: t("tanks.details.data.fill.graph.filling"),
				type: "column",
				data: fillings.map( (datum) => datum.qtyFilled)
			},
			{
				name: t("tanks.details.data.fill.graph.optimal"),
				type: "line",
				data: []
			}
		];
	}

	const mapDates = () => {
		return fillings.map( (datum) => {
			return formatDatesSet(datum.fillDate,null,i18n);
		})
	};

	const labelLegend = [
		t("tanks.details.data.fill.graph.filling"),
	];

	return (
		<ReactApexChart
			options={{
				chart: {
					height: 300,
					width: "100%",
					type: "column",
					stacked: false,
					zoom: { enabled: false },
					toolbar: { show: false },
				},
				plotOptions: {
					bar:{
						columnWidth: "70%",
					}
				},
				dataLabels: {
					enabled: false,
				},
				stroke: {
					dashArray: [0, 2],
					width: [2, 2],
				},
				colors: [
					"#F2994A",
					"#55B545"
				],
				xaxis: {
					type: "category",
					tooltip: { enabled: false },
					categories: mapDates()
				},
				yaxis:{
					min: 0,
					max: data[0].inventory.value,
					axisTicks: {
						show: true,
						offsetX: 0,
					},
					axisBorder: {
						show: true,
						color: "#DCDCDC",
						offsetX: 0,
					},
					labels: {
						style: { colors: "#333333" },
						formatter: function (val) {
							return Math.round(val) + " L";
						}
					},
					title: {
						text: t("tanks.details.data.fill.graph.yaxis_title"),
						style: { color: "#333333" },
					},
					tooltip: { enabled: false },
				},
				tooltip: {
					enabledOnSeries: [0],
					fixed: {
						enabled: false,
						position: "topLeft", // topRight, topLeft, bottomRight, bottomLeft
						offsetY: 0,
						offsetX: 0,
					},
				},
				legend: {
					horizontalAlign: "left",
					customLegendItems: labelLegend,
					offsetX: 40,
				},
			}}
			series={ mapSeries() }
			height={350}
		/>
	);
};

export default FillingGraph;
